import { SalesChannel } from "client/lib/apt-merchant";

export default function hasInstoreChannel(
  salesChannel?: SalesChannel
): boolean {
  return (
    salesChannel === "In-store Only" || salesChannel === "Online and In-store"
  );
}
